export const formatSearchLocationLabel = (url: string): string => {
    const paths = [
        /^\/for-sale\/[^/]*$/,
        /^\/new-homes\/[^/]*$/,
        /^\/to-rent\/[^/]*$/,
        /^\/new-homes\/developers\/[^/]*$/,
        /^\/house-prices\/[^/]*$/
    ];

    if (paths.some((pathRegex) => pathRegex.test(url))) {
        return '';
    }

    const splitUrl = url.split('/').filter((item) => item);

    if (splitUrl[0] === 'station' || splitUrl[0] === 'schools') {
        splitUrl.shift();
    }

    let formattedString = splitUrl
        .map((s) =>
            s
                .split('-')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')
        )
        .reverse()
        .join(', ');

    if (url.includes('/tube/') || url.includes('/rail/')) {
        formattedString += ' Station';
    }

    return formattedString;
};
